import type React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  Drawer as ShadcnDrawer,
  DrawerPortal as ShadcnDrawerPortal,
  DrawerOverlay as ShadcnDrawerOverlay,
  DrawerTrigger as ShadcnDrawerTrigger,
  DrawerClose as ShadcnDrawerClose,
  DrawerContent as ShadcnDrawerContent,
  DrawerHeader as ShadcnDrawerHeader,
  DrawerFooter as ShadcnDrawerFooter,
  DrawerTitle as ShadcnDrawerTitle,
  DrawerDescription as ShadcnDrawerDescription,
} from "src/shadcn/components/drawer";

const Drawer = (props: React.ComponentProps<typeof ShadcnDrawer>) => (
  <ShadcnDrawer {...props} />
);

const DrawerPortal = (
  props: React.ComponentProps<typeof ShadcnDrawerPortal>
) => <ShadcnDrawerPortal {...props} />;

const DrawerOverlay = (
  props: React.ComponentProps<typeof ShadcnDrawerOverlay>
) => <ShadcnDrawerOverlay {...props} />;

const DrawerTrigger = (
  props: React.ComponentProps<typeof ShadcnDrawerTrigger>
) => <ShadcnDrawerTrigger {...props} />;

const DrawerClose = (props: React.ComponentProps<typeof ShadcnDrawerClose>) => (
  <ShadcnDrawerClose {...props} />
);

const DrawerContent = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnDrawerContent>) => (
  <ShadcnDrawerContent className={cn("border-border", className)} {...props} />
);

const DrawerHeader = (
  props: React.ComponentProps<typeof ShadcnDrawerHeader>
) => <ShadcnDrawerHeader {...props} />;

const DrawerFooter = (
  props: React.ComponentProps<typeof ShadcnDrawerFooter>
) => <ShadcnDrawerFooter {...props} />;

const DrawerTitle = (props: React.ComponentProps<typeof ShadcnDrawerTitle>) => (
  <ShadcnDrawerTitle {...props} />
);

const DrawerDescription = (
  props: React.ComponentProps<typeof ShadcnDrawerDescription>
) => <ShadcnDrawerDescription {...props} />;

export {
  Drawer,
  DrawerPortal,
  DrawerOverlay,
  DrawerTrigger,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerFooter,
  DrawerTitle,
  DrawerDescription,
};
